import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

const Header = (props) => {
  const button = null;

  return (
    <div className="loginheader">
      <Paper elevation={3}>
        <Grid container sx={{ width: "100%" }}>
          <Grid size="grow">
            <img
              style={{ marginLeft: "5%", marginTop: "1%", marginBottom: "1%" }}
              src="https://www.aysa.com.ar/assets/Menu/img/logo.png"
              alt="aysa logo"
            />
          </Grid>
          <Grid size="grow">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div></div>
              <div
                style={{
                  alignSelf: "flex-end",
                  marginTop: "4%",
                  marginRight: "3%",
                }}
              >
                {" "}
                {props.button || button}
              </div>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};
export default Header;
